<div class="p-fluid p-grid">
  <div class="p-field p-col-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-fluid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"> </m-restricao-number>
        <m-restricao-string label="Nome" [restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>

        <m-restricao-entidade
          label="Dominio"
          [restricao]="ds.restricoes.atributo('dominio')"
          [itens]="dominioItens"
          itemId="value"
          itemLabel="label">
        </m-restricao-entidade>

        <m-restricao-entidade
          label="Método"
          [restricao]="ds.restricoes.atributo('metodo')"
          [itens]="metodoItens"
          itemId="value"
          itemLabel="label">
        </m-restricao-entidade>


        <m-restricao-entidade label="Requer Autenticação?"
          [restricao]="ds.restricoes.atributo('requerAutenticacao')" [itens]="requerAutenticacoesItens"
          itemId="value" itemLabel="label"></m-restricao-entidade>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-field p-col-12 p-lg-9">
    <p-card header="Lista de Recursos de Segurança">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id"  style="width: 5rem;">
              <div class="p-d-flex p-jc-between p-ai-center">Id<p-sortIcon field="id"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="nome">
              <div class="p-d-flex p-jc-between p-ai-center">Nome<p-sortIcon field="nome"></p-sortIcon>
              </div>
            </th>

            <th class="p-text-center p-col-1">Domínio</th>
            <th class="p-text-center p-col-2">Método</th>

            <th pSortableColumn="requerAutenticacao">
              <div class="p-d-flex p-jc-between p-ai-center p-text-center"> Requer Autenticação?<p-sortIcon field="requerAutenticacao"></p-sortIcon>
              </div>
             </th>
            <th class="p-text-center p-action">Ação</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-entity>
          <tr>
            <td>{{entity.id}}</td>
            <td class="p-text-break">{{entity.nome}}</td>
            <td>
              {{entity.dominio | dominio: 'getDominios'}}
            </td>
            <td >
              <span>
                {{ entity.dominio === 'BACKEND' ? entity.metodo : 'Não se aplica' }}</span> <br>

            </td>
            <td class="p-text-center">
              <span class="badge" [ngClass]="entity.requerAutenticacao ? 'badge-success' : 'badge-danger'">
                {{entity.requerAutenticacao | dominio: 'getSimNaoItens'}}
              </span>
            </td>
            <td class="p-text-center">
              <a pButton [routerLink]="['/recursoSeguranca/edicao/', entity.id]" icon="pi pi-pencil"
                      class="p-button-sm p-m-r-2" pTooltip="Editar">
              </a>
              <button
                pButton (click)="startDelete(entity)"
                class="p-button-danger p-button-sm"
                icon="pi pi-trash"
                pTooltip="Excluir">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6">
              <a pButton routerLink="/recursoSeguranca/novo" class="p-primary" label="Novo"></a>
            </div>
            <div class="p-field p-col-6 p-text-right">
              Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
